import React, {Component} from 'react';
import styled from "styled-components";

import StoreS3 from './../../manifest/util/StoreS3.jsx';

const PageContent = styled.div`
    margin: 0;
`;

const PremiseWrapper = styled.div`
    display: inline-block;
    width: 38%;
    padding: 0 0 0 0.75rem;
    margin: 0;
    vertical-align: top;    
`;

const ComputationWrapper = styled.div`
    display: inline-block;
    width: 56%;
    margin: 0;
    padding: 0 0.75rem 0 0;
    vertical-align: top;    
`;

const PremiseText =styled.div`
    font-size: 1.50rem;
    color: #666666;
    text-align: center;
`;

const ComputationText =styled.div`
    font-size: 1.0rem;
    font-family: Courier;
    color: #222222;
    font-weight: bold;
    text-align: center;
`;

const ComputationImage =styled.img`
    width: 75%;
`;

export class ModulusEffectExtra extends Component {

    state = {
        ready_to_go: false,
        extra_data: {}
    };

    componentDidMount() {
        this.load_content();
    }

    async load_content() {
        const extra_data = await StoreS3.get_file_tree('topics/modulus-effect');
        console.debug("extra_data", extra_data)
        this.setState({
            ready_to_go: true,
            extra_data: extra_data
        });
    }

    render() {
        if (!this.state.ready_to_go) {
            return '...';
        }
        const image_url = "https://mikehallstudio.s3.amazonaws.com/manifest/" + this.state.extra_data.computation.extra_items[0].path;
        return <PageContent>
            <ComputationWrapper>
                <ComputationImage src={image_url} />
                <ComputationText>{this.state.extra_data.computation.value}</ComputationText>
            </ComputationWrapper>
            <PremiseWrapper>
                <PremiseText>{this.state.extra_data.premise.value}</PremiseText>
            </PremiseWrapper>
        </PageContent>
    }
}

export default ModulusEffectExtra;
